// extracted by mini-css-extract-plugin
export default {"container":"Participants_container__b9csC"};